import React from 'react';
import styled from 'styled-components';
import { IconNames } from '@blueprintjs/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';
import { Icon, Intent } from '@blueprintjs/core';

import slug from 'constants/slug';
import { getOneInspectionDetail } from 'api/inspectionApi';
import Clearfix from 'components/elements/clearfix';
import DisplayField from 'components/elements/display-field';
import Confirm from 'components/elements/confirm-element';
import AttachmentContainer from 'containers/AttachmentContainer';
import {
  getList as getAttachList,
  deleteOne as deleteAttach,
  create as createAttach,
} from 'api/inspectionAttachmentApi';
import { getLookupTypeInspectionAttachment } from 'api/lookuplistitemApi';
import { DATE_FORMAT, DATETIME_FORMAT } from 'config';
import { COLOR } from 'config';

const ContainerWrapper = styled.div``;
const ContainerHeader = styled.div`
  display: flex;
`;
const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const Content = styled.div``;

@PageLockHOC(['facilityInspection.view'])
export default class InspectionViewChild extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: {},
  };

  getId() {
    const _id = _.result(this.props, 'match.params._id');
    return _id;
  }

  getParentId() {
    const parentId = _.result(this.props, 'match.params.parentId');
    return parentId;
  }

  async getOneInspectionDetail() {
    const _id = this.getId();
    if (_id) {
      const res = await getOneInspectionDetail(_id);
      if (res.success) {
        this.setState({
          isLoading: false,
          initialValue: _.get(res, 'data', {}),
        });
      }
    } else {
      this.props.history.push(slug.INSPECTTION.LIST);
    }
  }

  updateInitialValue = (values) => {
    this.setState({
      _idObject: values._id,
      isLoading: false,
      initialValue: values,
    });
  };

  componentWillMount = async () => {
    await Promise.all([this.getOneInspectionDetail()]);
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) {
      return '';
    }
    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  render() {
    return (
      <ContainerWrapper>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        {!this.state.isLoading && (
          <div>
            <ContainerHeader>
              <h3
                style={{
                  color: COLOR.SECOND_COLOR,
                }}
                className='bp3-heading'
              >
                Chi tiết thanh tra
              </h3>
            </ContainerHeader>
            <ContainerAction>
              <div style={{ display: 'inline-flex' }}>
                <Icon
                  onClick={() => {
                    this.props.history.push(
                      slug.INSPECTTION.VIEW_WITH_ID + this.getParentId()
                    );
                  }}
                  style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                  icon={IconNames.CIRCLE_ARROW_LEFT}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.SUCCESS}
                />

                <Permissions allowed={[`facilityInspection.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={`${slug.INSPECTTION.EDIT_WITH_ID_CHILD
                        }${this.getInitialValue('_id')}/${this.getParentId()}`}
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>
              </div>
            </ContainerAction>
            <Clearfix height={12} />
            <Content>
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Tên cơ sở/dự án'
                value={this.getInitialValue('Facility.FacilityNameFull', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Số quyết định đoàn thanh tra'
                value={this.getInitialValue(
                  'facilityInspection.InspectionNumber',
                  ''
                )}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Thời gian thanh tra'
                value={this.getInitialValue(
                  'facilityInspection.InspectionDate',
                  '',
                  'dates'
                )}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ngày ra quyết định'
                value={this.getInitialValue(
                  'facilityInspection.DecideDate',
                  '',
                  'date'
                )}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Cơ quan ban hành'
                value={this.getInitialValue(
                  'facilityInspection.AgencyIssued',
                  ''
                )}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ghi chú kế hoạch thanh tra'
                value={this.getInitialValue('InspectionNote', '')}
              />
              <Clearfix height={12} />
              <DisplayField size={14} label={<b>Kết luận thanh tra</b>} />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Số kết luận thanh tra'
                value={this.getInitialValue('ConcludeNumber', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Tên kết luận thanh tra'
                value={this.getInitialValue('ConcludeName', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ghi chú kết quả thanh tra'
                value={this.getInitialValue('ConcludeDesc', '')}
              />
              <Clearfix height={12} />
              <DisplayField size={14} label={<b>Xử lý vi phạm thanh tra</b>} />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Số quyết định xử phạt'
                value={this.getInitialValue('FinedNumber', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Tên quyết định xử phạt'
                value={this.getInitialValue('FinedName', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Cơ quan ra quyết định'
                value={this.getInitialValue('FinedAgency', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ngày ra quyết định'
                value={this.getInitialValue('FinedDate', '', 'date')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Tiền phạt'
                value={this.getInitialValue('FinedMoney', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ghi chú xử lý vi phạm hành chính'
                value={this.getInitialValue('FinedNotes', '')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Thêm vào'
                value={`${this.getInitialValue(
                  'AddedOn',
                  '',
                  'date_1'
                )} bởi ${this.getInitialValue('AddedBy', '')}`}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Cập nhật lần cuối'
                value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${this.getInitialValue('UpdatedBy', '')
                    ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
                    : ''
                  }`}
              />
            </Content>
            <Clearfix height={32} />
            <AttachmentContainer
              // hideButtonAction={this.state.isEdit ? false : true}
              facility={this.state.initialValue}
              getListFunc={(query) => {
                return getAttachList({
                  ...query,
                  inspection: this.getInitialValue('_id'), //_id của inspection
                });
              }}
              createOne={(values) => {
                values.inspection = this.getInitialValue('_id');
                return createAttach(_.pickBy(values, _.identity));
              }}
              deleteOne={deleteAttach}
              getAttachmentTypeList={getLookupTypeInspectionAttachment}
              moduleName='facilityInspection'
            />
          </div>
        )}
      </ContainerWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Inspection/InspectionViewChild/index.js